import {
    Button,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Grid,
    LinearProgress,
    Paper,
    Select,
    FormControl,
    MenuItem,
    InputLabel,
    Stack,
    TextField
  } from "@mui/material";
  import React, { useState, useEffect } from "react";
  import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
  import { Link as RLink, useHistory } from "react-router-dom";
  import { useParams } from "react-router-dom";
  import SearchableDropdown from "../../components/SearchableDropdown";
  import adminService from "../../services/admin";
  import configurationTM from "../../services/ConfigurationTM";
  
  import { USER_TYPE } from "../../const";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import CancelIcon from '@mui/icons-material/Cancel';
import InputsComponent from "../../components/Inputs";
import moment from "moment";
import  "./Configuration.css"

  
  let _password: string = ""; // for referencing

  // entire form works on single state
const initState:any = {
  // interacting form
  id:null,
  showForm:false,
  CurrentPlan:null,
  subscriptions:[],plans:[],
  
  // fields
  Account: {id:'',text:''},
  CSP:'',SubscriptionID:'',
  BillingType:'csp',BillingPlan:'METER_ELP_TIERS',
  Title:'',Length:'',StartDate:new Date(),EndDate: new Date().setMonth(new Date().getMonth()+6),PublicRatesDiscount:0,
  OverConsumptionCondition:'keep_discounting',
  EndContractCondition:'keep_discounting',EndContractCustomDiscount:0,
  SurrenderFee:false,SurrenderFeeAmount:0,

  Status:null,
  // -- detail fields
  Volume:0,VolumeDiscount:0,
  MonthlyContractAmount:0,MonthlyBill:0,MonthlyBillingDay:0, 
  OverConsumptionAllowancePercentage:0,OverConsumptionCustomDiscount:0,

  UpfrontContractAmount:0,UpfrontBillingDate:new Date(),
  // Tiers:defaultTiers,
  // Months:defaultMonths
}
  
  const ValidatorEnginnerForm: React.FC = ({handlerOnCloseELPmodel,data}:any) => {
    const param = useParams();
    const history = useHistory();
  
    const mode = param.id ? "update" : "create";
  
    const [processing, setProcessing] = useState(false);
    const [approverNotes,setApproverNotes]= useState('')
  
    const [Email, setEmail] = useState("");
    const [FullName, setFullName] = useState("");
    const [ChangePassword, setChangePassword] = useState(false);
    const [Role, setRole] = useState("Sales");
    const [Password, setPassword] = useState("");
    const [ConfirmPassword, setConfirmPassword] = useState("");
    const [IsCustomer, setIsCustomer] = useState<boolean>(false);
    const [IsAPIUser, setIsAPIUser] = useState<boolean>(false);
    const [APIGroup, setAPIGroup] = useState<any|null>([{name:"USAGE",value:false},{name:"BILLING",value:false}]);
    const [AccountID, setAccountID] = useState<string>("");
    const [OrganisationName, setOrganisationName] = useState<string>("");
    const [PartnerCompany, setPartnerCompany] = useState<string>("");
    const [FormData,setFormData] = useState<any>(initState);
    const [inputs, setInputs] = useState(['']); // Store the input values in state
    const [inputHours, setInputHours] = useState([]);
    const [sku,setSku] = useState(null)
    const [approval,setApproval] = useState(null)
    const setField = ({name,value})=>{
      // setFormData((_state)=>({..._state,[name]:value}));
  }
  
  const getField = (name)=>{
    return FormData[name]
}
    _password = Password;
  
    const setData = (data: any) => {
      if (data) {
        setEmail(data.Email);
        setFullName(data.FullName);
        setRole(data.Role);
        setIsCustomer(data?.UserType === USER_TYPE?.CUSTOMER);
        setIsAPIUser(data.Role === "API");
        setPartnerCompany(data.PartnerCompany)
        if (data?.UserType === USER_TYPE?.CUSTOMER) {
          setOrganisationName(data.OrganisationName);
        }
        setAccountID(data.AccountID);
        if (data.ApiGroups && data.ApiGroups.length != 0)
        {
          for(let row of APIGroup)
            {
              if (data.ApiGroups.indexOf(row.name) !== -1)
                row.value = true
            }
        }
      } else {
        setEmail("");
        setFullName("");
        setRole("Sales");
      }
    };
  
    const handlerOnSelectAccount = (account: any) => {
      if (account) setAccountID(account.id);
    };
  
    const getRecord = async () => {
      setProcessing(true);
      let res: any = await adminService.users.get({ id: param.id });
      if (!res.success) {
        window.snakAlert.error(res.message);
        setData(null);
      } else {
        if (res.success && res.data) {
          setData(res.data);
        } else {
          window.snakAlert.error(res.message);
        }
      }
      setProcessing(false);
    };
    const fetchSku = async () => {
      // setProcessing(true);
      let res: any = null;
      res = await configurationTM.getSku(null)
      if (!res.success) {
        window.snakAlert.error(res.message);
        setSku(null);
      } else {
        if (res.success && res.data) {
          setSku(res.data);
        } else {
          window.snakAlert.error(res.message);
        }
      }
      setProcessing(false);
    };

    const getApprovedByUser = async () => {
      // setProcessing(true);
      let res: any = null;
      res = await configurationTM.getApprovedBuyUser({ID:data.ID})
      if (!res.success) {
        // window.snakAlert.error(res.message);
        setApproval(null);
      } else {
        if (res.success && res.data) {
          setApproval(res.data);
        } else {
          // window.snakAlert.error(res.message);
        }
      }
      // setProcessing(false);
    };
  
    const handleSubmit = async (mode:any) => {
      setProcessing(true);

      let res: any = null;
      
      res = await configurationTM.createApprovals({
        ...data,
        approverNotes,
        approved:mode=== 'Approved'?true:false,
      })
      if (!res.success) {
        window.snakAlert.error(res.message);
      } else {
        if (res.success && res.data) {
          handlerOnCloseELPmodel()
          window.snakAlert.success(res.data);
        } else {
          window.snakAlert.error(res.message);
        }
      }
      setProcessing(false);
  
    };
    const handleChangeRole = (e: any) => {
      setRole(e.target.value);
    };
  
    useEffect(() => {
      fetchSku()
      getApprovedByUser()
      if(data?.StartDate){
        setField({name: 'StartDate', value:new Date(data?.StartDate)})
        setField({name: 'EndDate', value:new Date(data?.EndDate)})
        setField({name: 'summary', value:data?.Summary})
        setField({name: 'details', value:data?.Notes})
        setInputs(JSON.parse(data?.TmCount))
        const newCount = JSON.parse(data?.TmCount).toString()
        const  convertToNumbersArray = newCount.split`,`.map(x=>+x);

        setInputHours(convertToNumbersArray)

      }
      if(!data?.StartDate){
        setField({name: 'StartDate', value:new Date()})
        setField({name: 'EndDate', value:new Date()})
        setField({name: 'summary', value:''})
        setField({name: 'details', value:''})
        setInputHours([])
        setInputs([''])

      }
      if (mode == "update") getRecord();
  
      // add custom validation for confirm password
      ValidatorForm.addValidationRule("isPasswordMatch", (value: string) => {
        if (value !== _password) {
          return false;
        }
        return true;
      });
      ValidatorForm.addValidationRule("validatePassword", (value: string) => {
        let regex = /^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
        return regex.test(value);
      });

      
      return () => {
        ValidatorForm.removeValidationRule("isPasswordMatch");
        ValidatorForm.removeValidationRule("validatePassword");
      };
    }, []);

    const handlerSelectAccount = (account:any)=> {
      setField({name:'Account',value:account});
      // if(account.id)
      //     loadInfo(account.id,null);
  }

  const getCSPs = ():Array<string> =>{
    if(getField('subscriptions')){
        let csp_set = new Set();
        for(let sub of getField('subscriptions')){
            csp_set.add(sub.cloud);
        }
        return Array.from(csp_set);
    }
    return [];
}
const getSubs = ():Array<string> =>{
    if(getField('subscriptions')){
        const records = getField('subscriptions').filter((sub)=>sub.cloud === getField('CSP'));
        if(records){
            let subs:Array<string> = [];
            for(let sub of records)
                subs.push(sub.sub_id);
            return subs;
        }
    }
    return [];
}

const handleInputChange = (index, value) => {
  const newInputs = [...inputs];
  newInputs[index] = value;
  setInputs(newInputs);
};
const hnadleHoursInputChange = (index, value) => {
  const newHoursInput = [...inputHours];
  newHoursInput[index] = value;
  setInputHours(newHoursInput);
};

const handleAddInput = () => {
  setInputs([...inputs, '']);
};

const handleDeleteInput = (index) => {
  const newInputs = [...inputs];
  newInputs.splice(index, 1);
  setInputs(newInputs);
};

function calculateTotalPrice(hours, sku) {
  const totalCost = hours.reduce((total, item) => {
    return total + ((sku?.Price / 40) * item);
  }, 0);

  return totalCost;
}
// const calculateTotalPrice = (arr)=>{
//   let price:any;
//  const amount = arr.map((item:any)=>{
// console.log(item,'284')
// console.log(sku)
//     price = (sku?.Price/40) * item
//     return price
//  })

//  console.log(price,'cost');
//  return price;
// }


  
    return (
      <>
        <div className="page-content">
          <h2>
          Approver Form{" "}
            <span> {mode == "update" ? "Update User" : ""} </span>
          </h2>
  
          {mode == "update" ? (
            <Paper elevation={1} className="section mt-10">
              User Email: <strong>{Email}</strong>
            </Paper>
          ) : (
            ""
          )}
          <LinearProgress
            className="progress-bar"
            style={{ display: processing ? "" : "none" }}
          />
          <Paper elevation={1} style={{display:"flex",justifyContent:'space-between',alignItems:'top'}} className="section mt-10">
            <div style={{width:'80%'}}>


            <ValidatorForm
              onSubmit={handleSubmit}
              onError={(errors) => {
                console.log(errors);
              }}
            >
              <Grid container spacing={4}>
                <Grid item md={6} xs={12}>

                <Grid item md={12} mt={5}>
                <FormControl variant="standard" fullWidth>

                  <TextField label='Customer' name="CustomerDomain" disabled value={data?.CustomerDomain}  required/>
                </FormControl>
                            {/* <SearchableDropdown 
                                label="Search Customer" 
                                action="searchAccount" 
                                disabled={true}
                                //params={{acid:'0011P00001E3bAoQAJ'}}
                                onSelect={(value:any)=> handlerSelectAccount(value) } 
                            />        
                        </Grid> */}
</Grid>
                        <Grid item md={12} mt={5}>
                            <FormControl variant="standard" fullWidth>
                                {/* <InputLabel id="CSP">CSP</InputLabel> */}
                                <TextField label='CSP' disabled value={data?.CSP.toUpperCase()}  required/>
                                {/* <Select
                                    id="csp_id"
                                    labelId="CSP"
                                    name="CSP"
                                    disabled={true}
                                    // value={getField("CSP")}
                                    // onChange={handlerChangeCloud}
                                    // disabled={readonly}
                                >
                                    {['Aviatrix csp','zoom csp','billing csp'].map((csp:string,index:number)=>(
                                        <MenuItem key={index} value={csp}>{csp.toUpperCase()}</MenuItem>
                                    ))}
                                </Select> */}
                            </FormControl>
                        </Grid>

                        <Grid item md={12} mt={5}>
                            <FormControl variant="standard" fullWidth>
                                {/* <InputLabel id="subs_id">Subscription</InputLabel> */}
                                <TextField label='Subscription' name="SubId" disabled value={data?.SubId}  required/>
                                {/* <Select
                                    id="subs_id"
                                    labelId="Subscription"
                                    name="SubscriptionID"
                                    value={getField("SubscriptionID")}
                                    label="Subscription"
                                    disabled={true}
                                    // onChange={handleChangeSubscription}
                                    // disabled={readonly}
                                >
                                    {['TYooMQauvdEDq54NiTphI7jx','4eC39HqLyjWDarjtT1zdp7dc',].map((sub:string,index:number)=>(
                                        <MenuItem key={index} value={sub}>{sub}</MenuItem>
                                    ))}
                                </Select> */}
                            </FormControl>
                        </Grid>




                  <Grid item md={12} xs={12} mt={5}>
                  <FormControl variant="standard" fullWidth>
                                {/* <InputLabel id="subs_id">Subscription</InputLabel> */}
                                <TextField label='Start Date' disabled value={moment(data?.StartDate).format('MM/DD/YYYY')}  required/>
                                {/* <Select
                                    id="subs_id"
                                    labelId="Subscription"
                                    name="SubscriptionID"
                                    value={getField("SubscriptionID")}
                                    label="Subscription"
                                    disabled={true}
                                    // onChange={handleChangeSubscription}
                                    // disabled={readonly}
                                >
                                    {['TYooMQauvdEDq54NiTphI7jx','4eC39HqLyjWDarjtT1zdp7dc',].map((sub:string,index:number)=>(
                                        <MenuItem key={index} value={sub}>{sub}</MenuItem>
                                    ))}
                                </Select> */}
                            </FormControl>
                    
                  {/* <LocalizationProvider dateAdapter={DateAdapter}>
                            <Stack spacing={3}>
                            
                              <DesktopDatePicker
                                label="Start Date"
                                inputFormat="MM/DD/YYYY"
                                disabled={true}
                                // onChange={(e)=>handleChangeExamDate(e,index,"examDate")}
                                renderInput={(params) => <TextField {...params} required/>}
                              />

                            </Stack>

                      </LocalizationProvider> */}
                         
                  </Grid>
                  <Grid item md={12} xs={12} mt={5}>
                  <FormControl variant="standard" fullWidth>
                                {/* <InputLabel id="subs_id">Subscription</InputLabel> */}
                                <TextField label='End Date' disabled value={moment(data?.EndDate).format('MM/DD/YYYY')}  required/>
                                {/* <Select
                                    id="subs_id"
                                    labelId="Subscription"
                                    name="SubscriptionID"
                                    value={getField("SubscriptionID")}
                                    label="Subscription"
                                    disabled={true}
                                    // onChange={handleChangeSubscription}
                                    // disabled={readonly}
                                >
                                    {['TYooMQauvdEDq54NiTphI7jx','4eC39HqLyjWDarjtT1zdp7dc',].map((sub:string,index:number)=>(
                                        <MenuItem key={index} value={sub}>{sub}</MenuItem>
                                    ))}
                                </Select> */}
                            </FormControl>
                    
                  {/* <LocalizationProvider dateAdapter={DateAdapter}>
                            <Stack spacing={3}>
                            
                              <DesktopDatePicker
                                label="End Date"
                                inputFormat="MM/DD/YYYY"
                                disabled={true}
                                // onChange={(e)=>handleChangeExamDate(e,index,"examDate")}
                                renderInput={(params) => <TextField {...params} required/>}
                              />

                            </Stack>

                      </LocalizationProvider> */}
                         
                  </Grid>
                  <Grid item md={12} mt={5} style={{border: 'dashed #f9956f 0.5px',padding:'10px'}}>
                    <InputsComponent approver={true}
                                           inputs={inputs} 
                                           handleInputChange={handleInputChange} 
                                           handleAddInput={handleAddInput}
                                           handleDeleteInput={handleDeleteInput}
                                           hnadleHoursInputChange={hnadleHoursInputChange}
                                           inputHours={inputHours}
                                           disabled={true}
                    />
                    {inputHours.length ? (
                                                <div style={{width:'100%',display:'flex',justifyContent:'flex-end',alignItems:'center'}}>

<p>Total Cost: </p>
<p>${calculateTotalPrice(inputHours,sku)}</p>

                      </div>

                    ):null}
                          
                        </Grid>
                  {/* <Grid item md={12} xs={12} mt={5}>
                  <TextValidator 
                                      size="small" 
                                      fullWidth
                                      variant="outlined" 
                                      type="number" 
                                      label="T&M Count"  
                                      // margin="dense"
                                      placeholder='' 
                                      name="workedHours"
                                      autoFocus
                                      disabled={true}
                                      // InputProps={{ inputProps: {  min: 0.01, max: 500 ,step:0.01},startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                                      // value={UnitPrice.toFixed(3)}
                                      // onChange={(e)=>setUnitPrice(parseFloat(e.target.value))} 
                                      // validators={["required"]}
                                      // errorMessages={["UnitPrice is required"]}
                                  />
                  </Grid> */}

                  <Grid md={12} mt={5}>
<TextValidator
                  
                    variant="outlined"
                    // margin="dense"
                    fullWidth
                    label="Summary"
                    name="Summary"
                    size="small"
                    autoFocus
                    placeholder ='Summary'
                    value={data?.Summary}
                    
                    // onChange={(e: any) => {
                    //   setDescription(e.target.value);
                    // }}
                    // validators={["required"]}
                    // errorMessages={["Notes is required"]}
                    // value={Description}
                    disabled={true}
                    inputProps={{ maxLength: 500 }}
                    // style={{minHeight:'2rem'}}
                  />
                </Grid>

                  <Grid item md={12} xs={12} mt={5}>
                    <textarea value={data?.Notes} disabled style={{width:'100%',minHeight:'200px'}} placeholder ='Details' aria-label="Details"/>
                  
                </Grid>

                {
  !approval?.APPROVER_ID ? (
    <>
                <Grid md={12} mt={5}>
<TextValidator
                  
                    variant="outlined"
                    // margin="dense"
                    fullWidth
                    label="Approver Notes"
                    name="approverNotes"
                    size="small"
                    autoFocus
                    placeholder ='Approver Notes'
                    
                    onChange={(e: any) => {
                      setApproverNotes(e.target.value);
                    }}
                    value={approverNotes}
                    // validators={["required"]}
                    // errorMessages={["Notes is required"]}
                    // value={Description}
                    disabled={processing}
                    inputProps={{ maxLength: 500 }}
                    // style={{minHeight:'2rem'}}
                  />
                </Grid>

    <Grid item md={12}>
                    <br />
                    <Button
                      disabled={processing}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={()=>handleSubmit('Approved')}
                    >
                      Approved
                    </Button>
                    &nbsp; &nbsp;
                    <Button
                      // component={RLink}
                      // to="/configurations-services"
                      variant="contained"
                      // onClick={handlerOnCloseELPmodel}
                      onClick={()=>handleSubmit('Reject')}
                    >
                      Reject
                    </Button>
                  </Grid>
    </>
  ):null
}

                </Grid>
              </Grid>
            </ValidatorForm>
            </div>
            {/* <div style={{border:'solid lightgray',width:'20%',maxHeight:'200px',paddingLeft:'10px'}}>
              <div style={{}}>
                <div style={{width:'100%',display:'flex',alignItems:'center',gap:4}}>

<CheckCircleIcon style={{fill:"green"}} />

<p style={{fontWeight:'500'}}>Approved By Faizan Mustafa</p>
                </div>
              </div>
                <div style={{width:'100%',display:'flex',alignItems:'center',gap:4}}>

<PendingIcon style={{fill:"#ffb733"}} />

<p style={{fontWeight:'500'}}>Pending to Umer Farooq</p>
                </div>
                <div style={{width:'100%',display:'flex',alignItems:'center',gap:4}}>

<CancelIcon style={{fill:"red"}} />

<p style={{fontWeight:'500'}}>Rejected By Tabraiz Feham</p>
                </div>
            </div> */}
          </Paper>
          
        </div>
      </>
    );
  };
  
  export default ValidatorEnginnerForm;
  